import _ from 'lodash'
import React, { Component } from 'react'
import { Table, Popup, Button, Header, Label, Message, Icon, Placeholder } from 'semantic-ui-react'
import { connect } from "react-redux";

import { getTodosByVisibilityFilter, getTodosSorted } from "../redux/selectors";
import { VISIBILITY_FILTERS,SORT_COLUMNS} from "../constants";
import { toggleTodo, deleteTodo, setSort } from '../redux/actions';
import GoogleAnalytics from 'react-ga'


const sortOptions = [
  {
    key: SORT_COLUMNS.DATE,
    text: 'Datum',
    value: SORT_COLUMNS.DATE,
    icon: 'calendar alternate'
  },
  {
    key: SORT_COLUMNS.VALUE,
    text: 'Betrag',
    value: SORT_COLUMNS.VALUE,
    icon: 'money bill alternate',
  },
  {
    key: SORT_COLUMNS.RECIPIENT,
    text: 'Empfänger',
    value: SORT_COLUMNS.RECIPIENT,
    icon: 'address card',
  },
  {
    key: SORT_COLUMNS.PURPOSE,
    text: 'Zweck',
    value: SORT_COLUMNS.PURPOSE,
    icon: 'align left',
  },
  {
    key: SORT_COLUMNS.CATEGORY,
    text: 'Kategorie',
    value: SORT_COLUMNS.CATEGORY,
    icon: 'tag',
  },
]



//TODO: bessere tabelle machen: https://blog.kulturbanause.de/2012/06/tabellen-im-responsive-webdesign/https://blog.kulturbanause.de/2012/06/tabellen-im-responsive-webdesign/
class EntryTable extends Component {

  deleteEntry(id)
  {
    this.props.deleteTodo(id)
    GoogleAnalytics.event({category: 'Entry', action: 'Delete' });
  }

  formatValue(val)
  {
    const formattedNumber=new Intl.NumberFormat(undefined,{ 
      style: 'decimal', 
      useGrouping:true,
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).format(val);
    if(val > 0)
      return (
        <Label basic color="green">{formattedNumber}</Label>
      )
    else
      return formattedNumber;

  }

  handleChange = (e, clickedItem ) =>  { this.props.setSort(clickedItem.value) }


getDirection(column){
  return this.props.sorter.column === column ? this.props.sorter.asc ? "ascending":"descending" : null;
}

  render() {
    const isReadOnly = this.props.readOnly;
    
    if(!this.props.entries.length || this.props.entries.length == 0)
    return(
    <div>
      <Message info><Message.Header>Noch keine Einträge vorhanden.</Message.Header>
      <p>Bitte legen Sie einen Eintrag über das <Icon name="add"></Icon> an.</p></Message>
      <Placeholder>
        <Placeholder.Line length='full' />
        <Placeholder.Line length='very long' />
        <Placeholder.Line length='long' />
        <Placeholder.Line length='medium' />
        <Placeholder.Line length='short' />
        <Placeholder.Line length='very short' />
      </Placeholder>
    </div>
    )
    else

    return (
      <div>
         <Header>Einträge</Header>
      <Table sortable striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="right"
              sorted={this.getDirection(SORT_COLUMNS.DATE)}
              onClick= {()=>this.props.setSort(SORT_COLUMNS.DATE)} >
              Datum
            </Table.HeaderCell>
            <Table.HeaderCell
              sorted={this.getDirection(SORT_COLUMNS.RECIPIENT)}
              onClick= {()=>this.props.setSort(SORT_COLUMNS.RECIPIENT)} >
              Empfänger
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2"
              sorted={this.getDirection(SORT_COLUMNS.CATEGORY)}
              onClick= {()=>this.props.setSort(SORT_COLUMNS.CATEGORY)} >
              Kategorie
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="right"
              sorted={this.getDirection(SORT_COLUMNS.VALUE)}
              onClick= {()=>this.props.setSort(SORT_COLUMNS.VALUE)}>
              Betrag
            </Table.HeaderCell>
{!isReadOnly && 
            <Table.HeaderCell rowSpan="2" collapsing>
              #
            </Table.HeaderCell>
}
          </Table.Row>
          <Table.Row>
          <Table.HeaderCell
              sorted={this.getDirection(SORT_COLUMNS.PURPOSE)}
              onClick= {()=>this.props.setSort(SORT_COLUMNS.PURPOSE)} >
              Zweck
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>


{ this.props.entries.map((entry, index) => (

            <Table.Row key={entry.id} verticalAlign='top'>
              <Table.Cell textAlign="right">{new Intl.DateTimeFormat(undefined,{year:"numeric", month:"2-digit", day:"2-digit"}).format(entry.date)}</Table.Cell>
              <Table.Cell>{entry.recipient}<br />
              {entry.purpose}</Table.Cell>
              <Table.Cell><Label tag>{entry.category}</Label></Table.Cell>
              <Table.Cell textAlign="right">
              {this.formatValue(entry.value)}
</Table.Cell>
{!isReadOnly && 
              <Table.Cell textAlign="right">
                <Popup trigger={<Button  icon="delete" size="mini" onClick={()=>this.deleteEntry(entry.id)}></Button>} content='Eintrag löschen' />
                </Table.Cell>
}
            </Table.Row>
        ))}
        </Table.Body>
        <Table.Footer>
      <Table.Row verticalAlign="top">
        <Table.HeaderCell colSpan="2">{this.props.numberOfEntries} Einträge</Table.HeaderCell>
        <Table.HeaderCell />
        <Table.HeaderCell textAlign="right">Summe<br />{this.formatValue(this.props.sumOfEntries)}</Table.HeaderCell>
        {!isReadOnly && 
        <Table.HeaderCell />
        }
      </Table.Row>
    </Table.Footer>
      </Table>
   
      </div>
    )
  }
}
const mapStateToProps = state => {
  const { sorter } = state;
  //const entries = getTodosByVisibilityFilter(state, visibilityFilter);
  const entries = getTodosSorted(state, sorter);
  const numberOfEntries=entries.length;
  const sumOfEntries=_.reduce(entries, function(sum, n) {
    return sum + n.value;
    }, 0);

  return { sorter, entries, sumOfEntries, numberOfEntries };
  //   const allTodos = getTodos(state);
  //   return {
  //     todos:
  //       visibilityFilter === VISIBILITY_FILTERS.ALL
  //         ? allTodos
  //         : visibilityFilter === VISIBILITY_FILTERS.COMPLETED
  //           ? allTodos.filter(todo => todo.completed)
  //           : allTodos.filter(todo => !todo.completed)
  //   };
};
// export default TodoList;
//export default connect(mapStateToProps)(EntryTable);
//export default EntryTable //connect(state => ({ todos: getTodos(state) }))(EntryTable);
export default connect(mapStateToProps,{toggleTodo, deleteTodo, setSort})(EntryTable);